/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ workflow: NonNullable<unknown>, count: NonNullable<unknown>, statuses: NonNullable<unknown> }} Pwf_SummaryInputs */

const en_pwf_summary = /** @type {(inputs: Pwf_SummaryInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`From now on this product uses ${i?.workflow}. Items that move: ${i?.count} (statuses involved: ${i?.statuses}).`)
};

const de_pwf_summary = /** @type {(inputs: Pwf_SummaryInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ab jetzt nutzt dieses Produkt ${i?.workflow}. Vorgänge, die wandern: ${i?.count} (beteiligte Status: ${i?.statuses}).`)
};

/**
* | output |
* | --- |
* | "From now on this product uses {workflow}. Items that move: {count} (statuses involved: {statuses})." |
*
* @param {Pwf_SummaryInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const pwf_summary = /** @type {((inputs: Pwf_SummaryInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pwf_SummaryInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_pwf_summary(inputs)
	return en_pwf_summary(inputs)
});